import { WBBox, WBFlex, WBSvgIcon, WBTypography } from '@admiin-com/ds-web';
import { InputLabel, useTheme } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import React from 'react';

import UserIcon from '../../../../assets/icons/user.svg';
import useSelectedFirm from '../../../hooks/useSelectedFirm/useSelectedFirm';
import { getPendingSignersFromAnnotations } from '../../../helpers/signature';
import { useTaskCreationContext } from '../../../features/providers/TaskCreationProvider/useTaskCreationContext';
import { Signer } from '../../../features/providers/TaskCreationProvider/TaskCreationProvider';
export const SentUsers = () => {
  const { control, setValue } = useFormContext();
  const { t } = useTranslation();
  const { taskType } = useTaskCreationContext();
  const isTaxType = taskType === 'tax';

  const annotationsJson = useWatch({ name: 'annotations', control });

  const signers = getPendingSignersFromAnnotations(annotationsJson);

  const { selectedFirm } = useSelectedFirm();

  React.useEffect(() => {
    if (isTaxType) {
      setValue('from', selectedFirm);
    }
  }, [isTaxType, selectedFirm, setValue]);

  return (
    <>
      {signers.length > 0 && (
        <WBTypography variant="h5" mt={5}>
          {t('documentWillBeSentTo', { ns: 'taskbox' })}
        </WBTypography>
      )}
      <WBFlex flexDirection={'column'} gap={2}>
        {signers.map((signer: Signer, index: number) => (
          <React.Fragment key={index}>
            <WBFlex gap={3} alignItems={'center'} display={['none', 'flex']}>
              <WBTypography>{index + 1}</WBTypography>
              <WBFlex flex={1}>
                <WBBox flex={1} minWidth="50%" pr={2}>
                  <TextFormField
                    label={t('name', { ns: 'taskbox' })}
                    value={signer.name}
                    icon={
                      <WBSvgIcon fontSize="small" color="#000">
                        <UserIcon />
                      </WBSvgIcon>
                    }
                  />
                </WBBox>
                <WBBox flex={1} minWidth="50%" pr={2}>
                  <TextFormField
                    label={t('email', { ns: 'taskbox' })}
                    value={signer.email}
                  />
                </WBBox>
                {/*<WBBox flex={1} minWidth="50%">*/}
                {/*  <TextFormField*/}
                {/*    label={t('mobile', { ns: 'contacts' })}*/}
                {/*    value={signer.mobile ?? t('noNumber', { ns: 'taskbox' })}*/}
                {/*  />*/}
                {/*</WBBox>*/}
              </WBFlex>
            </WBFlex>
            <WBFlex gap={3} key={index} display={['flex', 'none']}>
              <WBTypography>{index + 1}</WBTypography>
              <WBBox>
                <WBTypography fontWeight={'bold'}> {signer.name}</WBTypography>
                <WBTypography color={'text.secondary'}>
                  {signer.email}
                </WBTypography>
                {signer.mobile ? (
                  <WBTypography color={'text.secondary'}>
                    {signer.mobile}
                  </WBTypography>
                ) : (
                  <WBTypography color={'text.secondary'}>
                    {t('noNumber', { ns: 'taskbox' })}
                  </WBTypography>
                )}
              </WBBox>
            </WBFlex>
          </React.Fragment>
        ))}
      </WBFlex>
    </>
  );
};

export const TextFormField = ({
  label,
  value,
  icon,
}: {
  icon?: React.ReactNode;
  label: string;
  value: string;
}) => {
  const theme = useTheme();
  return (
    <WBBox width="100%" maxWidth="100%">
      <InputLabel>{label}</InputLabel>
      <WBFlex
        sx={{
          borderBottom: `2px solid ${theme.palette.divider}`,
          alignItems: 'center',
          gap: 1,
          minHeight: '50px',
          maxWidth: '100%',
        }}
      >
        {icon}
        <WBTypography noWrap sx={{ lineHeight: '48px' }}>
          {value ?? 'pdf'}
        </WBTypography>
      </WBFlex>
    </WBBox>
  );
};
